import React, { useState, useRef, useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import { downloadQRLabel } from "../../../utils/qrLabelPrint";
import "./assetRegister.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Select from "react-select";
//import { FaUser, FaBuilding, FaLayerGroup, FaLaptop, FaKeyboard, FaMouse, FaDesktop, FaMoneyBill, FaCalendarAlt, FaStickyNote, FaIndustry, FaBox, FaFileInvoice, FaHourglassHalf } from "react-icons/fa";
import { CompanyOptions } from "../../Data/Company";
import { DEPARTMENTS } from "../../Data/department";
import { departmentCodes} from '../../Data/departmentcode';
import {companyCodes} from '../../Data/Companycode';
import { handleImageSelection } from "../../../utils/imageUpload";




const AssetRegister = () => {
  const user = JSON.parse(localStorage.getItem("currentUser"));
  const [isSubmitting, setIsSubmitting] = useState(false);

  /* ================= BASIC ================= */
  const [name, setName] = useState(user?.username || "");
  const [company, setCompany] = useState("");
  const [department, setDepartment] = useState("");

  /* ================= CATEGORY ================= */
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [type, setType] = useState("");
  const [subComponent, setSubComponent] = useState("");

  /* ================= COMMON FIELDS ================= */
  const [assetName, setAssetName] = useState("");
  const [assetprice, setAssetPrice] = useState("");
  const [assetModel, setAssetModel] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [assetUpdateDate, setAssetUpdateDate] = useState("");
  const [assetUserName, setUserName] = useState("");
  const [specialNote, setSpecialNote] = useState("");
  const [assetImage, setAssetImage] = useState(null);

  /* ================= MISSING STATES ADDED ================= */
  const [customType, setCustomType] = useState("");
  const [computerComponents, setComputerComponents] = useState("");

  /* ================= FULL SET ================= */
  const [CPUassetName, setCPUAssetName] = useState("");
  const [CPUassetModel, setCPUAssetModel] = useState("");
  const [CPUserialNumber, setCPUSerialNumber] = useState("");
  const [CPUprice, setCPUprice] = useState("");
  const [assetCPUImage, setCPUAssetImage] = useState(null);

  const [MoniterassetName, setMoniterAssetName] = useState("");
  const [MoniterassetModel, setMoniterAssetModel] = useState("");
  const [MoniterserialNumber, setMoniterSerialNumber] = useState("");
  const [Moniterprice, setMoniterprice] = useState("");
  const [assetMoniterImage, setMoniterAssetImage] = useState(null);

  const [MouseassetName, setMouseAssetName] = useState("");
  const [MouseassetModel, setMouseAssetModel] = useState("");
  const [MouseserialNumber, setMouseSerialNumber] = useState("");
  const [Mouseprice, setMouseprice] = useState("");
  const [assetMouseImage, setAssetMouseImage] = useState(null);

  const [KeyboardassetName, setKeyboardAssetName] = useState("");
  const [KeyboardassetModel, setKeyboardAssetModel] = useState("");
  const [KeyboardserialNumber, setKeyboardSerialNumber] = useState("");
  const [Keyboardprice, setKeyboardprice] = useState("");
  const [assetKeyboardImage, setAssetKeyboardImage] = useState(null);

  /* ================= QR ================= */
  const [qrCodeData, setQrCodeData] = useState(null);
  const [trackingId, setTrackingId] = useState("");
  const qrCodeContainerRef = useRef();

  /* ================= BRAND NEW or USED ================= */
  const [conditionType, setConditionType] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [invoiceDetails, setInvoiceDetails] = useState("");
  const [purchaseDate, setPurchaseDate] = useState("");
  const [warranty, setWarranty] = useState("");

  /* ================= Image Upload ================= */
  const [invoiceFile, setInvoiceFile] = useState(null);

  /* ================= OPTIONS ================= */
  

  

  /* ================= FETCH CATEGORY DATA ================= */
  useEffect(() => {
    axios
      .get("/api/categories/getCategory")
      .then((res) => setCategories(res.data))
      .catch((err) => console.error(err));
  }, []);

  /* ================= SELECT OPTIONS ================= */
  const categoryOptions = [...new Set(categories.map((c) => c.category))].map(
    (c) => ({ label: c, value: c }),
  );

  const typeOptions = category
    ? [
        ...new Set(
          categories
            .filter((c) => c.category === category.value)
            .map((c) => c.types),
        ),
      ].map((t) => ({ label: t, value: t }))
    : [];

  const subComponentOptions =
    category?.value === "IT & Communication Equipment" && type
      ? [
          ...new Set(
            categories
              .filter((c) => c.category === category.value && c.types === type)
              .map((c) => c.subComponent)
              .filter(Boolean),
          ),
        ]
      : [];

  /* ================= TRACKING ID ================= */
  const generateTrackingId = (serial) => {
    

    const comp = companyCodes[company] || "XX";
    const dep = departmentCodes[department] || "XX";

    const serialSuffix = serial ? serial.slice(-8) : "";
    const randomNum = `${new Date()
      .toISOString()
      .slice(2, 10)
      .replace(/-/g, "")
      .slice(0, 6)}${String(Math.floor(Math.random() * 100)).padStart(2, "0")}`;

    return serial
      ? `${comp}-${dep}-${serialSuffix}`
      : `${comp}-${dep}-${randomNum}`;
  };

  /* ================= FULL SET CHECK ================= */
  const isFullSet =
    category?.value === "IT & Communication Equipment" &&
    type === "Desktop Computers" &&
    subComponent === "Full Set";

  /* ================= QR GENERATE ================= */
  const handleGenerateQR = () => {
    if (
      !company ||
      !department ||
      !category ||
      !type ||
      !assetUserName ||
      !assetUpdateDate || !conditionType 
    ) {
      alert("Please fill in all required fields before submitting.");
      return;
    }

    if (type === "Desktop Computers" && !subComponent) {
    alert("Please select Sub Component for Desktop Computers.");
    return;
  }

  if (
  conditionType === "Brand New" &&
  (!supplierName || !invoiceDetails || !purchaseDate || !warranty)
) {
  alert("Please fill in all required fields before submitting.");
  return;
}


    let qrDataArray = [];

    if (isFullSet) {
      const items = [
        {
          asset: CPUassetName,
          serial: CPUserialNumber,
          model: CPUassetModel,
          assetImage: assetCPUImage,
          label: "CPU",
        },
        {
          asset: MoniterassetName,
          serial: MoniterserialNumber,
          model: MoniterassetModel,
          assetImage: assetMoniterImage,
          label: "Monitor",
        },
        {
          asset: MouseassetName,
          serial: MouseserialNumber,
          model: MouseassetModel,
          assetImage: assetMouseImage,
          label: "Mouse",
        },
        {
          asset: KeyboardassetName,
          serial: KeyboardserialNumber,
          model: KeyboardassetModel,
          assetImage: assetKeyboardImage,
          label: "Keyboard",
        },
      ];

      items.forEach((item) => {
        if (item.asset) {
          const id = generateTrackingId(item.serial);
          const qrData = `https://inv.vellaglobal.com/QRView/${id}`;
          //const qrData = `https://inv.vellaglobal.com/QRView/${id}`;
          qrDataArray.push({ company, qrData, trackingId: id, component: item.label });
        }
      });
    } else {
      const id = generateTrackingId(serialNumber);
      const qrData = `https://inv.vellaglobal.com/QRView/${id}`;
      qrDataArray.push({ company, qrData, trackingId: id });
    }

    setQrCodeData(qrDataArray);
  };

  /* ================= QR DOWNLOAD ================= */
  const handleDownloadQR = async (index, event) => {
    event.preventDefault();
    const asset = qrCodeData?.[index];
    if (!asset) return;
    try {
      await downloadQRLabel(asset);
    } catch (error) {
      window.alert(error.message || "Unable to download the QR label.");
    }
  };

 

  const handleSubmit = async () => {
    if (isSubmitting) return; // 🚫 stop double click
    if (
      !company ||
      !department ||
      !category ||
      !type ||
      !assetUserName ||
      !assetUpdateDate || !conditionType || !assetName 
    ) {
      alert("Please fill all required fields.");
      return;
    }

   if (type === "Desktop Computers" && !subComponent) {
    alert("Please select Sub Component for Desktop Computers.");
    return;
  }
     

    if (
  conditionType === "Brand New" &&
  (!supplierName || !invoiceDetails || !purchaseDate || !warranty)
) {
  alert("Please fill in all required fields before submitting.");
  return;
}

    

    setIsSubmitting(true); // 🔒 LOCK BUTTON

    try {
      if (isFullSet) {
        const components = [
          {
            assetName: CPUassetName,
            serialNumber: CPUserialNumber,
            model: CPUassetModel,
            assetprice: CPUprice,
            assetImage: assetCPUImage,
            label: "CPU",
          },
          {
            assetName: MoniterassetName,
            serialNumber: MoniterserialNumber,
            model: MoniterassetModel,
            assetprice: Moniterprice,
            assetImage: assetMoniterImage,
            label: "Monitor",
          },
          {
            assetName: MouseassetName,
            serialNumber: MouseserialNumber,
            model: MouseassetModel,
            assetprice: Mouseprice,
            assetImage: assetMouseImage,
            label: "Mouse",
          },
          {
            assetName: KeyboardassetName,
            serialNumber: KeyboardserialNumber,
            model: KeyboardassetModel,
            assetprice: Keyboardprice,
            assetImage: assetKeyboardImage,
            label: "Keyboard",
          },
        ];

        for (const c of components) {
          if (c.assetName) {
            const id = generateTrackingId(c.serialNumber);

            const formData = new FormData();
            formData.append("name", name);
            formData.append("company", company);
            formData.append("department", department);
            formData.append("category", category.value);
            formData.append("type", type);
            formData.append("subComponent", subComponent);

            formData.append("assetName", c.assetName);
            formData.append("assetModel", c.model);
            formData.append("assetprice", c.assetprice);
            formData.append("assetUserName", assetUserName);
            formData.append("assetUpdateDate", assetUpdateDate);
            formData.append("serialNumber", c.serialNumber);
            formData.append("trackingId", id);
            formData.append("specialNote", specialNote);
            formData.append("computerComponents", c.label);

            formData.append("conditionType", conditionType);
            formData.append("supplierName", supplierName);
            formData.append("invoiceDetails", invoiceDetails);
            formData.append("purchaseDate", purchaseDate);
            formData.append("warranty", warranty);

            if (invoiceFile) {
              formData.append("invoiceFile", invoiceFile); // FILE UPLOAD
            }

            if (c.assetImage) {
              formData.append("assetImage", c.assetImage);
            }

           // await axios.post("/api/PendingAssetRegisterDetails",
           await axios.post(
              "/api/PendingAssetRegisterDetails",
              formData,
              { headers: { "Content-Type": "multipart/form-data" } },
            );
          }
        }
      } else {
        const id = qrCodeData[0]?.trackingId;
        const formData = new FormData();

        formData.append("name", name);
        formData.append("company", company);
        formData.append("department", department);
        formData.append("category", category.value);
        formData.append("type", type);
        formData.append("subComponent", subComponent);

        formData.append("assetName", assetName);
        formData.append("assetModel", assetModel);
        formData.append("assetprice", assetprice);
        formData.append("assetUserName", assetUserName);
        formData.append("assetUpdateDate", assetUpdateDate);
        formData.append("serialNumber", serialNumber);
        formData.append("trackingId", id);
        formData.append("specialNote", specialNote);

        formData.append("computerComponents", computerComponents);
        formData.append("conditionType", conditionType);
        formData.append("supplierName", supplierName);
        formData.append("invoiceDetails", invoiceDetails);
        formData.append("purchaseDate", purchaseDate);
        formData.append("warranty", warranty);

        if (invoiceFile) {
          formData.append("invoiceFile", invoiceFile);
        }

        if (assetImage) {
          formData.append("assetImage", assetImage);
        }

         await axios.post(
        "/api/PendingAssetRegisterDetails",
       // await axios.post(
          //"/api/PendingAssetRegisterDetails",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        );
      }

      alert("Assets submitted successfully!");
      resetForm();
    } catch (err) {
      console.error(err);
      alert(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Unable to register the asset. Please check the entered information."
      );
    } finally {
      setIsSubmitting(false); // 🔓 ALWAYS UNLOCK BUTTON
    }
  };

  /* ================= RESET ================= */
  const resetForm = () => {
    setCompany("");
    setDepartment("");
    setCategory(""); // ✔ Correct for React-Select

    setType("");
    setCustomType("");
    setComputerComponents("");
    setAssetName("");
    setCPUAssetName("");
    setMoniterAssetName("");
    setMouseAssetName("");
    setKeyboardAssetName("");
    setAssetPrice("");
    setCPUprice("");
    setMoniterprice("");
    setMouseprice("");
    setKeyboardprice("");
    setAssetUpdateDate("");
    setSerialNumber("");
    setCPUSerialNumber("");
    setMoniterSerialNumber("");
    setMouseSerialNumber("");
    setKeyboardSerialNumber("");
    setCPUAssetModel("");
    setMoniterAssetModel("");
    setMouseAssetModel("");
    setKeyboardAssetModel("");
    setAssetModel("");
    setUserName("");
    setQrCodeData(null);
    setTrackingId("");
    setSpecialNote("");
    setConditionType("");
    setSupplierName("");
    setInvoiceDetails("");
    setPurchaseDate("");
    setWarranty("");
    setInvoiceFile("");
    setAssetImage("");
    setCPUAssetImage("");
    setMoniterAssetImage("");
    setAssetMouseImage("");
    setAssetKeyboardImage("");
  };

  /* ================= RENDER ================= */
  return (
    <div className="asset-register">
      <div className="form-containe con">
        <h2 className="registerhead">Asset Registration</h2>
        <p>
          <Link to="/AdminDashboardPage">DashBoard</Link> /
          <Link to="/assetregister">Asset Register</Link>
        </p>

        <div className="input-box">
          <div>
            <label className="iclabel">
              <i className="fas fa-user"></i> Register User
            </label>
            <input type="text" value={name} readOnly placeholder="Your Name" />
          </div>
          {/* BRAND NEW / USED */}
          <div className="brandnew-box">
            <label>
              <strong>Condition:</strong>
            </label>
            <div>
              <label style={{ marginRight: "15px" }}>
                <input
                  type="radio"
                  name="condition"
                  value="Brand New"
                  checked={conditionType === "Brand New"}
                  onChange={() => setConditionType("Brand New")}
                />{" "}
                Brand New
              </label>

              <label>
                <input
                  type="radio"
                  name="condition"
                  value="Used"
                  checked={conditionType === "Used"}
                  onChange={() => setConditionType("Used")}
                />{" "}
                Used
              </label>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <Select
                placeholder="Select Company"
                options={CompanyOptions}
                value={CompanyOptions.find((o) => o.value === company) || null}
                onChange={(o) => setCompany(o?.value || "")}
                isClearable
              />
            </div>

            <div className="col-md-6 mb-3">
              <Select
                placeholder="Select Department"
                options={DEPARTMENTS}
                value={
                  DEPARTMENTS.find((o) => o.value === department) || null
                }
                onChange={(o) => setDepartment(o?.value || "")}
                isClearable
              />
            </div>

            <div className="col-md-6 mb-3">
              <Select
                placeholder="Select Category"
                options={categoryOptions}
                value={category}
                onChange={(o) => {
                  setCategory(o);
                  setType("");
                  setSubComponent("");
                }}
                isClearable
              />
            </div>

            {category && (
              <div className="col-md-6 mb-3">
                <Select
                  placeholder="Select Type"
                  options={typeOptions}
                  value={type ? { label: type, value: type } : null}
                  onChange={(o) => setType(o?.value || "")}
                  isClearable
                />
              </div>
            )}
          </div>

          {subComponentOptions.length > 0 && (
            <Select
              placeholder="Select Sub Component"
              options={subComponentOptions.map((s) => ({ label: s, value: s }))}
              value={
                subComponent
                  ? { label: subComponent, value: subComponent }
                  : null
              }
              onChange={(o) => setSubComponent(o?.value || "")}
            />
          )}

          {/* FULL SET UI */}
          {isFullSet && (
            <div className="fullset-components row">
              {/* CPU */}
              <div className="col-md-6">
                <div className="asset-box">
                  <div className="asset-header">
                    <input type="checkbox" checked readOnly />
                    <span>CPU</span>
                  </div>

                  <div className="asset-fields">
                    <input
                      type="text"
                      placeholder="Asset Name"
                      value={CPUassetName}
                      onChange={(e) => setCPUAssetName(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Model"
                      value={CPUassetModel}
                      onChange={(e) => setCPUAssetModel(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Serial"
                      value={CPUserialNumber}
                      onChange={(e) => setCPUSerialNumber(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Price"
                      value={CPUprice}
                      onChange={(e) => setCPUprice(e.target.value)}
                    />
                  </div>
                  <div className="invoice-upload">
                    <label htmlFor="assetCPUImage" className="upload-card">
                      {!assetCPUImage ? (
                        <>
                          <i className="fa fa-image upload-icon"></i>
                          <p className="upload-title">Upload CPU Image</p>
                          <span className="upload-subtitle">
                            Camera or Gallery
                          </span>
                        </>
                      ) : (
                        <div className="preview-container">
                          <img
                            src={URL.createObjectURL(assetCPUImage)}
                            alt="Asset"
                          />
                          <span className="uploaded-badge">Uploaded</span>

                          <button
                            type="button"
                            className="remove-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setCPUAssetImage(null);
                            }}
                          >
                            ✕
                          </button>
                        </div>
                      )}
                    </label>

                    <input
                      id="assetCPUImage"
                      type="file"
                      accept="image/*"
                      hidden
onChange={(e) => handleImageSelection(e, setCPUAssetImage)}
                    />
                  </div>
                </div>
              </div>

              {/* Monitor */}
              <div className="col-md-6">
                <div className="asset-box">
                  <div className="asset-header">
                    <input type="checkbox" checked readOnly />
                    <span>Moniter</span>
                  </div>

                  <div className="asset-fields">
                    <input
                      type="text"
                      placeholder="Asset Name"
                      value={MoniterassetName}
                      onChange={(e) => setMoniterAssetName(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Model"
                      value={MoniterassetModel}
                      onChange={(e) => setMoniterAssetModel(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Serial"
                      value={MoniterserialNumber}
                      onChange={(e) => setMoniterSerialNumber(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Price"
                      value={Moniterprice}
                      onChange={(e) => setMoniterprice(e.target.value)}
                    />
                  </div>
                  <div className="invoice-upload">
                    <label htmlFor="assetMoniterImage" className="upload-card">
                      {!assetMoniterImage ? (
                        <>
                          <i className="fa fa-image upload-icon"></i>
                          <p className="upload-title">Upload Moniter Image</p>
                          <span className="upload-subtitle">
                            Camera or Gallery
                          </span>
                        </>
                      ) : (
                        <div className="preview-container">
                          <img
                            src={URL.createObjectURL(assetMoniterImage)}
                            alt="Asset"
                          />
                          <span className="uploaded-badge">Uploaded</span>

                          <button
                            type="button"
                            className="remove-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setMoniterAssetImage(null);
                            }}
                          >
                            ✕
                          </button>
                        </div>
                      )}
                    </label>

                    <input
                      id="assetMoniterImage"
                      type="file"
                      accept="image/*"
                      hidden
onChange={(e) => handleImageSelection(e, setMoniterAssetImage)}
                    />
                  </div>
                </div>
              </div>

              {/* Mouse */}
              <div className="col-md-6">
                <div className="asset-box">
                  <div className="asset-header">
                    <input type="checkbox" checked readOnly />
                    <span>Mouse</span>
                  </div>
                  <div className="asset-fields">
                    <input
                      type="text"
                      placeholder="Asset Name"
                      value={MouseassetName}
                      onChange={(e) => setMouseAssetName(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Model"
                      value={MouseassetModel}
                      onChange={(e) => setMouseAssetModel(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Serial"
                      value={MouseserialNumber}
                      onChange={(e) => setMouseSerialNumber(e.target.value)}
                    />
                    <input
                      type="text"
                      placeholder="Price"
                      value={Mouseprice}
                      onChange={(e) => setMouseprice(e.target.value)}
                    />
                  </div>
                  <div className="invoice-upload">
                    <label htmlFor="assetMouseImage" className="upload-card">
                      {!assetMouseImage ? (
                        <>
                          <i className="fa fa-image upload-icon"></i>
                          <p className="upload-title">Upload Mouse Image</p>
                          <span className="upload-subtitle">
                            Camera or Gallery
                          </span>
                        </>
                      ) : (
                        <div className="preview-container">
                          <img
                            src={URL.createObjectURL(assetMouseImage)}
                            alt="Asset"
                          />
                          <span className="uploaded-badge">Uploaded</span>

                          <button
                            type="button"
                            className="remove-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setAssetMouseImage(null);
                            }}
                          >
                            ✕
                          </button>
                        </div>
                      )}
                    </label>

                    <input
                      id="assetMouseImage"
                      type="file"
                      accept="image/*"
                      hidden
onChange={(e) => handleImageSelection(e, setAssetMouseImage)}
                    />
                  </div>
                </div>
              </div>

              {/* Keyboard */}
              <div className="col-md-6">
                <div className="asset-box">
                  <div className="asset-header">
                    <input type="checkbox" checked readOnly />
                    <span>Keyboard</span>
                  </div>

                  <div className="asset-fields">
                    <input
                      type="text"
                      placeholder="Asset Name"
                      value={KeyboardassetName}
                      onChange={(e) => setKeyboardAssetName(e.target.value)}
                    />

                    <input
                      type="text"
                      placeholder="Model"
                      value={KeyboardassetModel}
                      onChange={(e) => setKeyboardAssetModel(e.target.value)}
                    />

                    <input
                      type="text"
                      placeholder="Serial"
                      value={KeyboardserialNumber}
                      onChange={(e) => setKeyboardSerialNumber(e.target.value)}
                    />

                    <input
                      type="text"
                      placeholder="Price"
                      value={Keyboardprice}
                      onChange={(e) => setKeyboardprice(e.target.value)}
                    />
                  </div>

                  <div className="invoice-upload">
                    <label htmlFor="keyboardImage" className="upload-card">
                      {!assetKeyboardImage ? (
                        <>
                          <i className="fa fa-image upload-icon"></i>
                          <p className="upload-title">Upload Keyboard Image</p>
                          <span className="upload-subtitle">
                            Camera or Gallery
                          </span>
                        </>
                      ) : (
                        <div className="preview-container">
                          <img
                            src={URL.createObjectURL(assetKeyboardImage)}
                            alt="Keyboard"
                          />
                          <span className="uploaded-badge">Uploaded</span>

                          <button
                            type="button"
                            className="remove-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setAssetKeyboardImage(null);
                            }}
                          >
                            ✕
                          </button>
                        </div>
                      )}
                    </label>

                    <input
                      id="keyboardImage"
                      type="file"
                      accept="image/*"
                      hidden
onChange={(e) => handleImageSelection(e, setAssetKeyboardImage)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* SINGLE ENTRY FIELDS */}
          {!isFullSet && (
            <>
              <div className="row">
                <div className="col-md-6 mb-1">
                  <label className="iclabel">
                    <i className="fas fa-layer-group"></i> Asset Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Asset Name"
                    value={assetName}
                    onChange={(e) => setAssetName(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="iclabel">
                    <i className="fa fa-suitcase"></i> Asset Model Number
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Asset Model Number"
                    value={assetModel}
                    onChange={(e) => setAssetModel(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="iclabel">
                    <i class="fa fa-gear"></i> Serial Number
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Serial Number"
                    value={serialNumber}
                    onChange={(e) => setSerialNumber(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="iclabel">
                    <i class="fa fa-comment-dollar"></i> Price
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Price"
                    value={assetprice}
                    onChange={(e) => setAssetPrice(e.target.value)}
                  />
                </div>

                <div className="invoice-upload">
                  <label htmlFor="assetImage" className="upload-card">
                    {!assetImage ? (
                      <>
                        <i className="fa fa-image upload-icon"></i>
                        <p className="upload-title">Upload Asset Image</p>
                        <span className="upload-subtitle">
                          Camera or Gallery
                        </span>
                      </>
                    ) : (
                      <div className="preview-container">
                        <img
                          src={URL.createObjectURL(assetImage)}
                          alt="Asset"
                        />
                        <span className="uploaded-badge">Uploaded</span>

                        <button
                          type="button"
                          className="remove-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setAssetImage(null);
                          }}
                        >
                          ✕
                        </button>
                      </div>
                    )}
                  </label>

                  <input
                    id="assetImage"
                    type="file"
                    accept="image/*"
                    hidden
onChange={(e) => handleImageSelection(e, setAssetImage)}
                  />
                </div>
              </div>
            </>
          )}

          {/* COMMON FIELDS */}
          <div>
            <label className="iclabel">
              <i class="fa fa-handshake-angle"></i> EPF No &  Recipient Name
            </label>
            <input
              type="text"
              placeholder="Eg: 53 Pasindu Lakshan"
              value={assetUserName}
              onChange={(e) => setUserName(e.target.value)}
            />
          </div>

          <div>
            <label className="iclabel">
              <i class="fa fa-calendar-check"></i> Asset Register Date
            </label>
            <input
              type="date"
              value={assetUpdateDate}
              onChange={(e) => setAssetUpdateDate(e.target.value)}
            />
          </div>

          {/* EXTRA FIELDS FOR BRAND NEW */}
          {conditionType === "Brand New" && (
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="iclabel">
                  <i class="fa fa-truck-field"></i> Supplier Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Supplier Name"
                  value={supplierName}
                  onChange={(e) => setSupplierName(e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="iclabel">
                  <i class="fa fa-file-invoice"></i> Invoice Number
                </label>
                <input
                  type="text"
                  placeholder="Enter Invoice Number"
                  value={invoiceDetails}
                  onChange={(e) => setInvoiceDetails(e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="iclabel">
                  <i class="fa fa-calendar-plus"></i> Purchase Date
                </label>
                <input
                  type="date"
                  placeholder="Enter Purchase Date"
                  value={purchaseDate}
                  onChange={(e) => setPurchaseDate(e.target.value)}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="iclabel">
                  <i class="fa fa-award"></i> Warranty Period
                </label>

                <input
                  type="text"
                  placeholder="Enter Warranty Period"
                  value={warranty}
                  onChange={(e) => setWarranty(e.target.value)}
                />
              </div>

              <div className="invoice-upload">
                <label htmlFor="invoiceUpload" className="upload-card">
                  {!invoiceFile ? (
                    <>
                      <i className="fa fa-cloud-upload upload-icon"></i>
                      <p className="upload-title">Upload Invoice</p>
                      <span className="upload-subtitle">
                        Click or drag image here
                      </span>
                    </>
                  ) : (
                    <div className="preview-container">
                      <img
                        src={URL.createObjectURL(invoiceFile)}
                        alt="Invoice Preview"
                      />
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setInvoiceFile(null);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  )}
                </label>

                <input
                  id="invoiceUpload"
                  type="file"
                  accept="image/*"
                  hidden
onChange={(e) => handleImageSelection(e, setInvoiceFile)}
                />
              </div>
            </div>
          )}
          <div>
            <label className="iclabel">
              <i className="fa fa-clipboard"></i> Remarks / Special Note
            </label>
            <textarea
              className="specile_Note"
              placeholder=" Special Note"
              value={specialNote}
              onChange={(e) => setSpecialNote(e.target.value)}
            />
          </div>

          {/* QR PREVIEW */}
          {/* {qrCodeData && (
            <div ref={qrCodeContainerRef} className="qr-preview row mt-3">
              {qrCodeData.map((qr, index) => (
                <div key={index} className="col-md-3 text-center">
                  <QRCode value={qr.qrData} size={120} />
                  <p>{qr.trackingId}</p>
                  <button
                    className="button"
                    onClick={(e) => handleDownloadQR(index, e)}
                  >
                    Download
                  </button>
                </div>
              ))}
            </div>
          )}*/}

          {qrCodeData && (
            <div ref={qrCodeContainerRef} className="qr-preview row mt-3">
              {qrCodeData.map((qr, index) => (
                <div key={index} className="col-md-3 text-center">
                  {/* FULL SET ITEM LABEL */}
                  {qr.component && (
                    <div className="qr-component-label">{qr.component}</div>
                  )}

                  <QRCode value={qr.qrData} size={120} />

                  <p className="qr-tracking-id">{qr.trackingId}</p>

                  <button
                    className="downlodbutton"
                    onClick={(e) => handleDownloadQR(index, e)}
                  >
                    Download
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* ACTION BUTTONS */}
          <div className="button-group mt-3">
            <button className="generate-btn" onClick={handleGenerateQR}>
              Generate QR
            </button>
            <button
              className="submit-btn1"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetRegister;
